module.exports = __webpack_public_path__ + "img/2.f00a0b97.png";